import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { DateAddXExpression } from "../../../rule-engine-core/Expressions/Expressions/Date/DateAddXExpression";
import { ObserveMultiState } from "../../../CommonUI/StateManagement/ObserveMultiState";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import { UISelect } from "../../../CommonUI/BuildlingBlocks/UISelect";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { DateSpanType } from "../../../rule-engine-core/Expressions/Expressions/Date/BaseDateCalculateExpression";
import React from "react";
import { ExpressionReactContext, ExpressionRenderType } from "../../Structure/ExpressionReactContext";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";
import { Box } from "@mui/material";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

function RenderEditor(props: { ruleData: DateAddXExpression }) {
    const context = React.useContext(ExpressionReactContext);

    return (
        <ObserveMultiState
            listenTo={[props.ruleData, props.ruleData!.adjustBy!, props.ruleData!.baseDate!]}
            control={() => (
                <GroupedBracketedDiv
                    issue={props.ruleData!.getValidationIssues()[0]}
                    hasChild={!!props.ruleData!.adjustBy!.subExpression || !!props.ruleData!.adjustBy!.subExpression}
                >
                    <ExpressionPiece paddingLeft={"10px"}> {"Add"} </ExpressionPiece>
                    <ExpressionPiece hasChild={!!props.ruleData!.adjustBy!.subExpression}>
                        <ExpressionValueRenderer el={props.ruleData!.adjustBy!} />
                    </ExpressionPiece>
                    {context.renderType !== ExpressionRenderType.FULL && (
                        <Box
                            alignItems={"center"}
                            paddingRight={"3px"}
                        >
                            <UILabel
                                variant={"small"}
                                color={"UIBlack"}
                            >
                                {props.ruleData.calculateType}
                            </UILabel>
                        </Box>
                    )}

                    {context.renderType === ExpressionRenderType.FULL && (
                        <Box
                            alignItems={"center"}
                            sx={{ lineHeight: "20px" }}
                        >
                            <UISelect
                                variant={"standard"}
                                onChange={(o) => {
                                    // @ts-ignore
                                    props.ruleData!.calculateType = o!;
                                    StateManager.changed(props.ruleData!);
                                }}
                                value={props.ruleData!.calculateType}
                                options={Object.values(DateSpanType)}
                                sx={{ color: UIStyleConstants.BLACK_COLOR, textTransform: "none" }}
                            ></UISelect>
                        </Box>
                    )}
                    <ExpressionPiece> {"to"} </ExpressionPiece>
                    <ExpressionPiece hasChild={!!props.ruleData!.baseDate!.subExpression}>
                        <ExpressionValueRenderer el={props.ruleData!.baseDate!} />
                    </ExpressionPiece>
                </GroupedBracketedDiv>
            )}
        />
    );
}

export class DateAddXExpressionEditor extends ExpressionRuleEditor<DateAddXExpression> {
    render() {
        return <RenderEditor ruleData={this.ruleData!} />;
    }
}
